import {useState, useMemo} from 'react';
import {defaults} from '../constants/defaults';

export const usePartialList = <T>(
  items: T[] | null,
  listSize = defaults.partialListSizeWithButton,
): [T[] | null, () => void, boolean] => {
  const [countOfShowMore, setCountOfShowMore] = useState(1);

  return useMemo(() => {
    const itemsToShow = items?.slice(0, listSize * countOfShowMore) || null;
    const showMore = () => {
      setCountOfShowMore(countOfShowMore + 1);
    };
    const allShown = itemsToShow?.length === items?.length;
    return [itemsToShow, showMore, allShown];
  }, [items, countOfShowMore]);
};
